import React from "react";
import logo from "./logo.svg";
import "./App.css";
import HomePage from "./components/HomePage";

function App() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

export default App;
